var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerForm',{attrs:{"data":_vm.data,"query":_vm.CREATE_CUSTOMER},on:{"mutation-done":_vm.customerCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }